module.exports = __webpack_public_path__ + "static/media/character-02.48a2cb05.png";